import { render, staticRenderFns } from "./HealthCeremonyModal.vue?vue&type=template&id=520b3c7b"
import script from "./HealthCeremonyModal.vue?vue&type=script&lang=js"
export * from "./HealthCeremonyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports